import React from 'react'
import { ReactComponent as TickIcon } from "assets/img/svg/TickIcon.svg";
import styles from "../../refundStyles.module.scss";

const Timeline = ({ steps }) => {
    return (
        <div className={styles['timeline-container']}>
            {steps.map((step, index) => (
                <div key={index} className={styles['timeline-step']}>
                    <div className={styles['icon-column']}>
                        <TickIcon className={styles['tick-icon']} />
                        {index < steps.length - 1 && <div className={styles['vertical-line']}></div>}
                    </div>
                    <div className={styles['content-column']}>
                        <div className={styles['step-label']}>{step.label}</div>

                        {step.subSteps?.length > 0 && (
                            <div className={styles['substeps-container']}>
                                {step.subSteps.map((sub, subIdx) => (
                                    <div key={subIdx} className={styles['substep']}>
                                        <div className={styles['substep-label']}>{sub.label}</div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Timeline;